import React from "react";
import style from './style.module.scss'
import UserMenu from './UserMenu'
import { connect } from 'react-redux';
import {ReducerType} from "../../../redux/reducer.type";
import { TopbarTypeProps } from "./topbar.type";
import {getSessionSuperAdminWorkspace} from "../../../utils/utils";
import {Typography} from "antd";

class TopBar extends React.Component<TopbarTypeProps, {}> {

    render(): React.ReactNode {
        const { header, user, isMobile } = this.props;
        const { Text } = Typography;
        return (
            <div className={style.topbar}>
                <div className={style.topbar_left}>
                    <h3 className={style.topbar_header}>{header.header}</h3>
                </div>
                {
                    sessionStorage.getItem("superAdminWorkspace") && !isMobile &&
                    <Text>Aktywny klient: <b>{getSessionSuperAdminWorkspace().name}</b></Text>
                }
                <div className={style.topbar_right}>
                    {user && !isMobile && (
                        <div className={style.air__menuLeft__user}>
                            <div className={style.air__menuLeft__user__name}>{user.first_name} {user.last_name}</div>
                            <div className={style.air__menuLeft__user__role}>{user.email}</div>
                        </div>
                    )}
                    <UserMenu />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ReducerType) =>({
    isMobile: state.settings.isMobileView,
    header: state.header,
    user: state.user
});

export default connect(mapStateToProps)(TopBar);
